import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-payment-invoice-table',
  templateUrl: './payment-invoice-table.component.html',
  styleUrls: ['./payment-invoice-table.component.css']
})
export class PaymentInvoiceTableComponent implements OnInit {

  @Input() invoiceDetailHa;
  @Input() adminId;
  @Output() clickAction = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  getInvoice (data) {
    this.clickAction.emit(data);
  }

}
